let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("iXPP1")).then(() => parcelRequire('6dj0L'));